// Angular
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()

export class FormsService {

    constructor() {
    }

    validate(formGroup: FormGroup, controlName: string): boolean {
        return formGroup.controls[controlName].invalid && formGroup.controls[controlName].touched;
    }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/forms/forms.service.ts